import React, { useState, useEffect } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { shallowEqual, useSelector } from 'react-redux';
import {toast} from 'react-toastify';
import { toastOption } from '../../../../../../../../_metronic/_helpers';

export const RejectModal = ({show, onHide, confirm}) => {
  const { actionsLoading, error } = useSelector(
    (state) => ({
      actionsLoading: state.kurbanReport.actionsLoading,
      error: state.kurbanReport.error
    }),
    shallowEqual,
  );
  
  const [rejectCommentInput, setRejectCommentInput] = useState("");
  
  useEffect(() => {
    if (error) {
      toast.error(error, toastOption);
    }
  }, [error]);

  function submitConfirm() {
    confirm(rejectCommentInput);
  }
  
  
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header className='bg-danger' closeButton>
        <Modal.Title className='text-white'>
          Pesan Untuk Mitra
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Comment Form */}
        <div className="w-100">
          <Form onSubmit={submitConfirm}>
            <Form.Group className="mb-3" controlId="formBasicText">
              <Form.Label>Keterangan</Form.Label>
              <Form.Control 
                as="textarea" 
                placeholder="Berikan keteragan mengenai penolakan data ini." 
                value={rejectCommentInput}
                onChange={(e) => setRejectCommentInput(e.target.value)}
              />
              {!rejectCommentInput &&
                <Form.Text className="text-danger">
                  Keterangan Wajib diisi.
                </Form.Text>
              }
            </Form.Group>
          </Form>
        </div>
        {/* Comment Form */}

        {/* Buttons */}
        <div className="d-flex flex-row justify-content-end">
          <Button className='mr-4' variant="secondary" onClick={onHide}>
            Kembali
          </Button>
          <Button width={75} variant="primary" onClick={submitConfirm}>
            {!actionsLoading ? 
              <span>
                Konfirmasi
              </span>
              :
              <span>
                <i className="fas fa-circle-notch fa-spin"></i>
              </span>
            }
          </Button>
          {/* Buttons */}
        </div>
      </Modal.Body>
    </Modal>
  );
}